import { submit_application_risk_assessments } from '@/services/onboarding_risk_service';
import { getSelectedForm } from './queue_form_method_shared';

function get_submit_blocking_message(instance) {
  if (!instance.can_submit_current_form) {
    return 'You can view this workflow step, but you cannot submit changes for it.';
  }
  if (!instance.selected_application_form_id) {
    return 'Select a form before saving.';
  }
  return '';
}

function build_submit_context(instance, options = {}) {
  const selected_form = getSelectedForm(instance.application_forms, instance.selected_application_form_id);
  return {
    selected_form,
    application_form_id: Number(selected_form?.application_form_id || instance.selected_application_form_id),
    application_id: Number(instance.$route.params.applicationId || 0),
    target_step: Number(options?.target_step || 0) || null,
    target_section_id: options?.target_section_id ?? null,
    preserve_current_step: options?.preserve_current_step === true || Number(options?.target_step || 0) > 0
  };
}

async function submit_form_answers(instance, application_form_id, application_id) {
  const standard_answers = instance.buildStandardAnswers();
  const file_payload = instance.buildFileAnswerPayload();

  if (file_payload.answers.length) {
    await instance.submit_file_answers(application_form_id, application_id, standard_answers, file_payload);
    return;
  }

  await instance.submit_standard_answers(application_form_id, application_id, standard_answers);
}

async function submit_risk_assessment(instance, application_id, selected_form) {
  return submit_application_risk_assessments({
    application_id,
    entity_profile_id: Number(instance.resolved_runtime_scope?.entity_profile_id || selected_form?.entity_profile_id || 0) || null,
    entity_type_id: Number(instance.resolved_runtime_scope?.entity_type_id || selected_form?.entity_type_id || 0) || null,
    project_id: Number(instance.resolved_runtime_scope?.project_id || selected_form?.project_id || 0) || null,
    selected_form,
    current_form_sections: instance.intake_steps,
    current_form_values: instance.form_values
  });
}

function dispatch_submit_events(application_id, application_form_id, risk_results) {
  window.dispatchEvent(new CustomEvent('onboarding-data-updated', {
    detail: {
      application_id,
      application_form_id,
      source: 'queue-form-submit'
    }
  }));
  window.dispatchEvent(new CustomEvent('onboarding-form-saved', {
    detail: {
      application_id,
      application_form_id,
      risk_results
    }
  }));
}

export const queueFormSubmitMethods = {
  async submit_selected_application_form(options = {}) {
    const blocking_message = get_submit_blocking_message(this);
    if (blocking_message) {
      this.form_page_error = blocking_message;
      return false;
    }

    const submit_context = build_submit_context(this, options);
    this.is_submitting = true;
    this.form_page_error = '';
    this.submit_success_message = '';

    try {
      await submit_form_answers(this, submit_context.application_form_id, submit_context.application_id);
      const risk_results = await submit_risk_assessment(
        this,
        submit_context.application_id,
        submit_context.selected_form
      );
      this.submit_success_message = 'The onboarding form was saved successfully.';
      await this.load_application_forms({
        preserve_current_step: submit_context.preserve_current_step,
        target_step: submit_context.target_step,
        target_section_id: submit_context.target_section_id
      });
      dispatch_submit_events(
        submit_context.application_id,
        submit_context.application_form_id,
        risk_results
      );
      return true;
    } catch (error) {
      this.form_page_error = error?.response?.data?.message || error?.message || 'Unable to save this onboarding form.';
      return false;
    } finally {
      this.is_submitting = false;
    }
  }
};
